<template>
  <notes
    :items="items"
    :loading="loading"
    @add-note="addNote"
    @delete-item="onDeleteNote"
  />
</template>

<script>
import { EventBus } from '@/event-bus.js';
import Notes from './Notes';

export default {
  components: {
    Notes,
  },
  computed: {
    customer() {
      return this.$store.state.customers.item;
    },
    loading() {
      return this.$store.state.customers.notesLoading;
    },
    // detailsLoading() {
    //   return this.$store.state.customers.detailsLoading;
    // },
    // details() {
    //   if (!this.customer) return {}
    //   return {
    //     member_of: this.customer.member_of,
    //     phone_number: this.customer.phone_number,
    //     birth_date: this.customer.birth_date,
    //     last_active: this.customer.last_active,
    //     based_in: this.customer.location,
    //   };
    // },
    items() {
      const { notes } = this.$store.state.customers;
      return notes.slice(0).sort((n1, n2) => this.$moment(n1.date).unix() < this.$moment(n2.date).unix()).reverse();
    },
  },
  watch: {
    'customer.pk': {
      handler(newval) {
        if (!newval) return;
        this.$store.dispatch('customers/fetchNotes', this.customer.pk);
      },
    },
  },
  methods: {
    addNote({ message }) {
      if (!this.customer) {
        console.error('Could not send note with an undefined customer!');
      }
      const payload = {
        text: message,
        customer: this.customer.pk,
        author: this.$store.state.account.user.profile.pk,
      };
      this.$store.dispatch('customers/addNote', payload);
    },
    onDeleteNote(noteId) {
      // Show confirmation
      EventBus.$emit('confirm', {
        message: 'Are you sure you\'d like to delete this Note?',
        callback: (confirm) => {
          if (confirm) {
            this.$store.dispatch('customers/deleteNote', noteId);
          }
        },
        positiveText: 'Delete',
      });
    },
    // patchCustomer(payload) {
    //   this.$store.dispatch('customers/patchCustomerInfo', payload)
    // },
    // deleteGroup(group_id) {
    //   this.$store.dispatch('customers/deleteGroupMember', {
    //     customer: this.customer.pk,
    //     id: group_id,
    //   })
    // },
  },
};
</script>

<style lang="scss" scoped>

</style>
